module.exports = __webpack_public_path__ + "img/shipo-menu-reports-white.8a812a2e.svg";